<template>
    <div class="form-field">

        <ValidationProvider name="products" v-slot="{ errors }" rules="required|min:3" persist>
            <input v-show="false" class="form-control" name="products" v-bind:value="productsStr">
            <p v-if="errors[0]" class="validation-error">{{ errors[0] }}</p>
        </ValidationProvider>

        <Row v-for="(product, idx) in value" :key="idx" class="mb-1">
            <Col>
                <ProductRepeaterItem :name="'products[' + idx + ']'"
                                     v-bind:value="product"
                                     :label="'Prescription Line ' + (idx+1)"
                                     @remove-product-line="() => removeProduct(product)"
                ></ProductRepeaterItem>
            </Col>
        </Row>

        <Row>
            <Col class="mb-3">
                <button @click.prevent="addProduct">
                  <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                  </svg>
                  Add Line
                </button>
            </Col>
        </Row>
    </div>
</template>

<script>
    import {ValidationProvider} from 'vee-validate'

    import Row from "../layout/Row";
    import Col from "../layout/Col";
    import ProductRepeaterItem from "../input/ProductRepeaterItem";

    export default {
        name: "ProductRepeater",
        props: ["value"],
        components: {
            Row,
            Col,
            ValidationProvider,
            ProductRepeaterItem
        },
        computed: {
            productsStr: function () {
                return JSON.stringify(this.value)
            }
        },
        methods: {
            addProduct: function () {
                const newValue = [...this.value, {desc: '', qty: 0}]
                this.$emit('input', newValue);
            },
            removeProduct: function (product) {
                const newValue = this.value.filter((p) => p !== product)
                this.$emit('input', newValue);
            }
        }
    }
</script>

<style lang="scss" scoped>
    button {
        background: #00477f;
        border-radius: 3px !important;
        border-color: #00477f;
        font-weight: 600;
        color: #ffffff;
        border-style: solid;

        &:hover{
            opacity: 0.75;
        }
    }
</style>
